import Vue from "vue";
import Router from "vue-router";
import NotFound from "./components/NotFound";
import sCache from "@/plugins/simple-cache";
import store from "./store";

Vue.use(Router);
Vue.use(sCache, { store });
/**
 * Setting the current logged in user.
 */
store.commit("login/initMsal");

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "login",
      //component: Home
      component: () =>
        import(/* webpackChunkName: "login" */ "./views/Login.vue"),
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "/about",
      name: "about",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/About.vue"),
    },
    {
      path: "/requestform",
      name: "requestform",
      component: () =>
        import(/* webpackChunkName: "requestform" */ "./views/RequestForm.vue"),
    },
    {
      path: "/deliveryform",
      name: "deliveryform",
      component: () =>
        import(
          /* webpackChunkName: "deliveryform" */ "./views/DeliveryForm.vue"
        ),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/callback",
      name: "callback",
      component: () =>
        import(/* webpackChunkName: "callback" */ "./views/Callback.vue"),
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "*",
      name: "notfound",
      component: NotFound,
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!(await store.dispatch("login/getToken"))) {
      next({ name: "login" });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
